<template>
  <div class="app-layout" >

    <section class="app-layout-main">
      <app-header />
      <app-body isNoSide/>
    </section>
  </div>
</template>

<script>
import {
  AppHeader, AppBody,
} from '@/components/index';

export default {
  name: 'Layout',
  components: {
    AppHeader,
    AppBody,
  },
};
</script>
<style lang="scss" scoped>
.app-layout-main {
  min-width: 800px;
  min-height: 100vh;
}
</style>
